import { useEffect, useContext, useState } from 'react';
import { FlexJustifyBetween, FlexAlignCenter, FlexColumnAlignStart } from '../shared/Flex';
import { Menu } from 'react-feather'
import { colors } from '../ui-elements/Main/MainTheme';
import image from '../../../../assets/images/avo-icon.svg';
import { useViewport } from '@/lib/layout/dimensions';
import { BalanceDropDown } from './BalanceDropDown';
import { ToggleSound } from './ToggleSound';
import { HelperAgent } from './HelperAgent';
import { DownTime } from './DownTime';
import { ChurnedHeader } from './Churned';
import { TrialHeader } from './TrialHeader';
import { ReminderHeader } from './ReminderHeader';
import { ToggleNotifications } from './ToggleNotifications';
import { ProfileAndSettings } from './ProfileAndSettings';
import { AccountLayout } from './AccountLayout';
import { AccountInfoContext } from '../account/account-info';
import styled from 'styled-components';
import { useNavigationActions } from '@/lib/navigation';
import { formatPhone } from '@/helpers/app/phone';
import { useSetupV3OrganizationsChannel, useSetupV3UserNotificationsChannel } from '@/hooks/websockets/setup';
import { useAddLeftNavListener } from '@/hooks/misc/useAddLeftNavListener';
import { updateBalanceRemaining } from '@/redux/app/actions/organization';
import { useInit } from '@/lib/react-hooks';
import { useDispatch, useSelector } from 'react-redux';
import { OrgInfoContext } from '../organization/org-info';
import { UserInfoContext } from '../user/user-info';
import { setUser } from '@/redux/app/actions/user';
import { accountPath, accountDashboardPath, accountNumbersPath } from '@/helpers/app/routes';
import { AppNavigatorPathContext } from '@/lib/navigation';
import { SosInfoContext } from '../sos/sos-info';
import { disableTcrBanner } from '@/redux/app/actions/user';
import menu from '../../../../assets/images/menu.svg';

export const Root = () => {
  const user = useContext(UserInfoContext);
  const { userId, admin, canViewBilling }  = useContext(UserInfoContext);
  const { name, phoneNumber, subdomain, isMessagingServiceSid, plan, isTollFreeNumber } = useContext(AccountInfoContext);
  const path = useContext(AppNavigatorPathContext);
  const { balanceRemaining, isChurned, canViewOrg, remindOfTcrDeadline } = useContext(OrgInfoContext);
  const { isDown } = useContext(SosInfoContext);
  const isMediumView = useViewport((width) => width <= 975, 500);
  const { nav, open, close } = useAddLeftNavListener();
  const isMobile = useViewport((width) => width < 600, 500);
  const isTrial = plan === 'trial-plan-4';
  const dispatch = useDispatch();
  const { navigate } = useNavigationActions();
  const isRemindUser = !isTrial && remindOfTcrDeadline && (canViewOrg || admin);
  const [isShowBanner, setIsShowBanner] = useState(remindOfTcrDeadline);
  const uiContent = document.querySelector('.ui-content') as HTMLElement | null;

  const accountInfo = useContext(AccountInfoContext);
  const isHelperBotAccount = accountInfo?.helperBotTargetAccount === true;
  const isHelperBotEnabled = accountInfo?.helperBotEnabled === true;
  useSetupV3UserNotificationsChannel();
  useSetupV3OrganizationsChannel();

  useEffect(() => {
    nav.classList.remove(open);
  }, [path]);

  useEffect(() => {
    if (uiContent && isMobile) {
      uiContent.style.paddingTop = '60px';
    }
  }, []);

  useInit(() => {
    dispatch(updateBalanceRemaining({ balanceRemaining }));
    dispatch(setUser({ user }));
  })

  const evalTitle = () => {
    if (phoneNumber) return formatPhone(phoneNumber);
    if (isMessagingServiceSid) return null;
    return 'Choose a Phone Number';
  };

  const handleDisableBanner = () => {
    dispatch(disableTcrBanner(userId));
    setIsShowBanner(false);
    uiContent.style.paddingTop = '60px';
  };

  return (
    <>
      <Container>
        <FlexAlignCenter>
          {isMediumView && (
            <LeftNav id="left-button" className="not-desktop left-elements" href="#leftNav" data-role="none">
              <img className="mr-10" src={menu} alt="menu" />
            </LeftNav>
          )}
          <img
            src={image}
            style={{ cursor: 'pointer', width: isMediumView ? '28px' : 'auto', margin: '0 10px' }}
            onClick={() => navigate({ path: accountPath(subdomain), params: {} })}
          />
          <FlexColumnAlignStart>
            <AccountLayout
              title={name}
              toolTipTitle="Your Organization"
              toolTipSubtitle="Tip: Click to view Account Dashboard"
              callback={() => navigate({ path: accountDashboardPath(subdomain), params: {} })}
            />
            <AccountLayout
              title={evalTitle()}
              color={colors.balanceGreen}
              toolTipTitle="Your Account Number"
              toolTipSubtitle="Tip: Click to view your Phone Number Settings"
              callback={() => navigate({ path: accountNumbersPath(subdomain), params: {} })}
            />
          </FlexColumnAlignStart>
        </FlexAlignCenter>
        {!isMobile && <FlexAlignCenter>
          {!isDown && isChurned && <ChurnedHeader />}
          {!isDown && isTrial && <TrialHeader />}
        </FlexAlignCenter>}
        {isDown && <DownTime />}
        <FlexAlignCenter>
          {!isMobile && (canViewBilling || admin) && <BalanceDropDown />}
          <FlexAlignCenter>
            <ToggleSound />
            <ToggleNotifications />
            { (!isHelperBotAccount && isHelperBotEnabled ) ? <HelperAgent/> : null }
            <ProfileAndSettings />
          </FlexAlignCenter>
        </FlexAlignCenter>
      </Container>
      {(isRemindUser && isShowBanner && !isMobile)
        && <ReminderHeader
          handleDisableBanner={handleDisableBanner}
        />
      }
    </>
  );
};

const Container = styled(FlexJustifyBetween)`
  position: relative;
  background: white;
  height: 60px;
  border-bottom: 1px solid rgba(224, 198, 183, 0.2);
  z-index: 1000;
`;

const LeftNav = styled.a`
  color: black;
  fill: black;
  top: 0;
  bottom: 0;
  left: 0;
  padding: 7px;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 25px;
    height: 25px;
  }
`;
